export default {
  'pages.reviews.title': '리뷰 관리',
  'pages.reviews.platformReviews': '플랫폼 리뷰',
  'pages.reviews.userReviews': '사용자 리뷰',
  'pages.reviews.platformToUser': '플랫폼 → 사용자 상품',
  'pages.reviews.userToProduct': '사용자 → 상품',
  'pages.reviews.platformReviewsDescription': '플랫폼에서 사용자 상품에 대해 작성한 리뷰',
  'pages.reviews.userReviewsDescription': '사용자가 상품에 대해 작성한 리뷰',
  
  // Common
  'pages.reviews.user': '사용자',
  'pages.reviews.sender': '발신자',
  'pages.reviews.seller': '판매자',
  'pages.reviews.rating': '평점',
  'pages.reviews.rating.positive': '긍정',
  'pages.reviews.rating.neutral': '중립',
  'pages.reviews.rating.negative': '부정',
  'pages.reviews.content': '내용',
  'pages.reviews.images': '이미지',
  'pages.reviews.imagesCount': '개',
  'pages.reviews.processingMemo': '처리 메모',
  'pages.reviews.createdAt': '작성일',
  'pages.reviews.updatedAt': '수정일',
  'pages.reviews.status': '상태',
  'pages.reviews.actions': '작업',
  
  // Platform Reviews
  'pages.reviews.platform.title': '제목',
  'pages.reviews.platform.status.active': '활성',
  'pages.reviews.platform.status.hidden': '숨김',
  'pages.reviews.platform.write': '리뷰 작성',
  'pages.reviews.platform.writeReview': '상품 리뷰 작성',
  'pages.reviews.platform.send': '전송',
  'pages.reviews.platform.reviewSent': '리뷰가 전송되었습니다',
  'pages.reviews.platform.reviewError': '리뷰 전송에 실패했습니다',
  'pages.reviews.platform.ratingRequired': '평점을 선택하세요',
  
  // User Reviews
  'pages.reviews.user.productInfo': '상품 정보',
  'pages.reviews.user.productNumber': '상품 번호',
  'pages.reviews.user.productName': '상품명',
  'pages.reviews.user.sellerName': '판매자',
  'pages.reviews.user.reviewText': '리뷰 내용',
  'pages.reviews.user.reviewImages': '리뷰 이미지',
  'pages.reviews.user.platformComment': '플랫폼 댓글',
  'pages.reviews.user.status.pending': '대기',
  'pages.reviews.user.status.approved': '승인',
  'pages.reviews.user.status.rejected': '거부',
  
  // Actions
  'pages.reviews.edit': '수정',
  'pages.reviews.delete': '삭제',
  'pages.reviews.approve': '승인',
  'pages.reviews.reject': '거부',
  'pages.reviews.comment': '댓글',
  'pages.reviews.commentAndNotes': '댓글/메모',
  'pages.reviews.action.view': '보기',
  'pages.reviews.action.respond': '응답',
  
  // Modal
  'pages.reviews.modal.commentTitle': '플랫폼 댓글',
  'pages.reviews.modal.editTitle': '플랫폼 리뷰 수정',
  'pages.reviews.modal.approveTitle': '리뷰 승인',
  'pages.reviews.modal.rejectTitle': '리뷰 거부',
  'pages.reviews.modal.platformComment': '플랫폼 댓글',
  'pages.reviews.modal.platformCommentPlaceholder': '사용자에게 보여질 댓글을 입력하세요...',
  'pages.reviews.modal.processingMemo': '처리 메모 (내부용)',
  'pages.reviews.modal.processingMemoPlaceholder': '내부 처리 메모를 입력하세요...',
  'pages.reviews.modal.handlingNotes': '처리 메모 (내부용)',
  'pages.reviews.modal.handlingNotesPlaceholder': '내부 처리 메모를 입력하세요...',
  'pages.reviews.modal.save': '저장',
  'pages.reviews.modal.cancel': '취소',
  'pages.reviews.contentRequired': '리뷰 내용을 입력하세요',
  'pages.reviews.contentPlaceholder': '리뷰 내용을 입력하세요...',
  'pages.reviews.handlingNotesRequired': '처리 메모를 입력하세요',
  'pages.reviews.handlingNotesPlaceholder': '처리 메모를 입력하세요...',
  'pages.reviews.imageUploadNote': '최대 5개 이미지 업로드 가능 (각 파일 최대 3MB)',
  'pages.reviews.addImage': '이미지 추가',
  
  // Messages
  'pages.reviews.deleteConfirm': '삭제하시겠습니까?',
  'pages.reviews.rejectConfirm': '거부하시겠습니까?',
  'pages.reviews.deleted': '삭제되었습니다',
  'pages.reviews.approved': '승인되었습니다',
  'pages.reviews.rejected': '거부되었습니다',
  'pages.reviews.commentSaved': '댓글이 저장되었습니다',
  'pages.reviews.commentRequired': '댓글을 입력하세요',
  'pages.reviews.fetchError': '리뷰 목록을 불러오는데 실패했습니다',
  'pages.reviews.deleteError': '삭제에 실패했습니다',
  'pages.reviews.updated': '리뷰가 수정되었습니다',
  'pages.reviews.updateError': '수정에 실패했습니다',
  'pages.reviews.commentError': '댓글 저장에 실패했습니다',
  'pages.reviews.approveError': '승인에 실패했습니다',
  'pages.reviews.rejectError': '거부에 실패했습니다',
  'pages.reviews.permissionDenied': '권한 없음',
  'pages.reviews.noPermissionToEdit': '이 리뷰를 수정할 권한이 없습니다',
  
  // Search
  'pages.reviews.search.userName': '사용자명',
  'pages.reviews.search.productName': '상품명',
  'pages.reviews.search.sellerName': '판매자명',
  'pages.reviews.search.title': '제목',
  
  // Suggestion page (Platform Reviews)
  'pages.suggestion.tab.item': '상품 품질 (Item as Described)',
  'pages.suggestion.tab.customerService': '고객 서비스 (Customer Service)',
  'pages.suggestion.tab.delivery': '배송 서비스 (Delivery Service Quality)',
  'pages.suggestion.item.title': '상품 품질 리뷰',
  'pages.suggestion.cs.title': '고객 서비스 리뷰',
  'pages.suggestion.delivery.title': '배송 서비스 리뷰',
  'pages.suggestion.reviewType': '리뷰 유형',
  'pages.suggestion.reviewType.item': '상품 품질',
  'pages.suggestion.reviewType.customerService': '고객 서비스',
  'pages.suggestion.reviewType.delivery': '배송 서비스',
  'pages.suggestion.detailTitle': '플랫폼 리뷰 상세',
  'pages.suggestion.responseTitle': '플랫폼 리뷰 응답',
};